import { render, staticRenderFns } from "./stories.vue?vue&type=template&id=907ae7ca"
import script from "./stories.vue?vue&type=script&lang=js"
export * from "./stories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports